import $ from 'jquery';
import { emitter } from './../utils/custom-events.js';
// The class for the container div
const $container = $('.tabs-container');

const $tabList = $('.js-bottom-wrapper .tabs-bar');
const $searchBar = $('.pusher .search');
const $pageHeadTitle = $($('.pusher .page-head .page-head__title')[0]);

function init() {
	// The setup
	$tabList
		.attr('role', 'tablist')
		.find('li').attr('role', 'presentation')
		.find('a')
		.attr({ role: 'tab', tabindex: '-1' });

	// Make each aria-controls correspond id of targeted section (re href)
	$tabList.find('a').each(function () {
		$(this).attr('aria-controls', $(this).attr('href'));
	});

	// Make each section focusable and give it the tabpanel role
	$container.find('section').attr({ role: 'tabpanel' });

	// Make first child of each panel focusable programmatically
	$container.find('section > *:first-child').attr({ tabindex: '0' });

	// Change focus between tabs with arrow keys
	$('[role="tab"]').on('keydown.tabs', function (e) {

		// define current, previous and next (possible) tabs
		const $original = $(this);
		const $prev = $(this).parents('li').prev().children('[role="tab"]');
		const $next = $(this).parents('li').next().children('[role="tab"]');
		let $target;

		// find the direction (prev or next)
		switch (e.keyCode) {
		case 37:
			$target = $prev;
			break;
		case 39:
			$target = $next;
			break;
		default:
			$target = false;
			break;
		}

		if ($target.length) {
			$original.attr({ tabindex: '-1', 'aria-selected': null });
			$target.attr({ tabindex: '0', 'aria-selected': true }).focus();
		}

		// Hide panels
		$container.find('[role="tabpanel"]').attr('aria-hidden', 'true');

		// Show panel which corresponds to target

		$(`${$(this).attr('href').replace('/', '')}`).attr('aria-hidden', null);

	});
}

// Handle click on tab to show + focus tabpanel

function open(tab) {
	const $item = $tabList.find(`.js-tab-${tab}`);
	$pageHeadTitle.text($item.find('span').text());

	// remove focusability [sic] and aria-selected
	$('[role="tab"]').attr({ tabindex: '-1', 'aria-selected': null });

	// replace above on clicked tab
	$item.attr({ 'aria-selected': true, tabindex: '0' });

	// Hide panels
	$container.find('[role="tabpanel"]').attr('aria-hidden', 'true');

	// show corresponding panel
	$(`#${tab}`).attr('aria-hidden', null);

	// hide/show search bar
	if ($item.attr('aria-selected') && $item.attr('aria-controls') === '/casino/all-games') {
		$searchBar.removeClass('search--js-hide');
		$searchBar.siblings('h2').removeClass('u-show').addClass('u-hide');
	} else {
		$searchBar.addClass('search--js-hide');
		$searchBar.siblings('h2').removeClass('u-hide').addClass('u-show');
	}
	window.lazySizes.loader.checkElems();
	emitter.emit('tabbed');
}

export {
	init,
	open
};

export default {
	init,
	open
};



// WEBPACK FOOTER //
// ./mobile-core/src/libs/tabs.js